import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TurnOneTextIntoTenPosts from "./sections/TurnOneTextIntoTenPosts";
import AsSeenInTrustedBy from "./sections/AsSeenInTrustedBy";
import StrategicOversightAreas from "./sections/StrategicOversightAreas";
import ConfidentialityPromise from "./sections/ConfidentialityPromise";
import TrustPeaceOfMind from "./sections/TrustPeaceOfMind";
import IntelligenceInMotion from "./sections/IntelligenceInMotion";
import ReadyForAFairOffer from "./sections/ReadyForAFairOffer";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TurnOneTextIntoTenPosts />
      <AsSeenInTrustedBy />
      <StrategicOversightAreas />
      <ConfidentialityPromise />
      <TrustPeaceOfMind />
      <IntelligenceInMotion />
      <ReadyForAFairOffer />
      <Footer />
    </div>;
}